import { Box } from "@chakra-ui/react";

const SVGIcon = ({ icon, size }) => {
  return <Box as="img" src={icon} alt="" width={size} height={size} />;
};

export default SVGIcon;
